export const CHANNEL_OPTIONS = [
    { ID: "ALL", Text: "All" },
    { ID: "whatsapp", Text: "WhatsApp" },
    { ID: "sms", Text: "SMS" },
    { ID: "email", Text: "Email" },
];

export const STATUS_OPTIONS = [
    { ID: "ALL", Text: "All" },
    { ID: "open", Text: "Open" },
    { ID: "pending", Text: "Pending" },
    { ID: "on_hold", Text: "On Hold" },
    { ID: "closed", Text: "Closed" },
];
